// Lightweight inline markdown -> HTML converter for SurveyJS text.
// Handles the small subset that survey authors use in questions/answers:
// bold, italic, inline code, and links. HTML is escaped first so the
// source text can never inject markup.

function escapeHtml(text) {
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

export function markdownToHtml(rawText) {
    if (typeof rawText !== "string" || rawText.length === 0) {
        return rawText;
    }

    let html = escapeHtml(rawText);

    // Links: [label](url) — only http(s) and mailto are allowed.
    html = html.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)/g,
        (match, label, url) =>
            `<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`
    );

    // Inline code: `code`
    html = html.replace(/`([^`]+)`/g, "<code>$1</code>");

    // Bold: **text** or __text__
    html = html.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/__([^_]+)__/g, "<strong>$1</strong>");

    // Italic: *text* or _text_
    html = html.replace(/\*([^*]+)\*/g, "<em>$1</em>");
    html = html.replace(/_([^_]+)_/g, "<em>$1</em>");

    return html;
}
